<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar operación / Edit Operation</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editOperationForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{operationData.id}}</p>
            <p><strong>Fecha de creación / Created: </strong>{{operationData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
            <mat-label>Operación / Operation</mat-label>
            <input matInput type="text"
                formControlName="operation" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('operation', 'required')">
                <strong>Campo requerido / Required Field</strong>
            </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
        <button mat-button cdkFocusInitial (click)="submit(editOperationForm)">Guardar / Save</button>
    </div>
</div>
